module.exports = __webpack_public_path__ + "static/media/faq2.ca2a9097.png";